export const DataTesti = [
    {
        id:1,
        image:"/Images/About/Testimonial/1.webp"
    },
    {
        id:2,
        image:"/Images/About/Testimonial/2.webp"
    },
    {
        id:3,
        image:"/Images/About/Testimonial/3.webp"
    },
    {
        id:4,
        image:"/Images/About/Testimonial/4.webp"
    },
    {
        id:5,
        image:"/Images/About/Testimonial/5.webp"
    },
    {
        id:6,
        image:"/Images/About/Testimonial/6.webp"
    },
];
